import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ContextMenuItem, ContextMenuService } from '@shared/components';
import { ResultContextMenuItem, TelemetryTrigger } from '../../views';

@UntilDestroy()
@Component({
  selector: 'split-button-wrapper',
  template: `<u-split-button
    [label]="this.label"
    [disabled]="this.disabled"
    (onDropdownClick)="open($event)"
    (onClick)="onClick.emit()"
    [styles]="styles"
    [elementSize]="elementSize"
  ></u-split-button>`,
  styleUrls: ['./split-button.wrapper.component.scss'],
})
export class SplitButtonWrapperComponent {
  @Input() label: string;
  @Input() disabled: boolean;
  @Input() items: Array<ContextMenuItem> = [];
  @Input() styles: any = {};
  @Input() elementSize: string;

  @Output() onClick = new EventEmitter();
  @Output() invoke = new EventEmitter<{ item: ResultContextMenuItem; trigger: TelemetryTrigger }>();

  constructor(private contextMenuService: ContextMenuService, private el: ElementRef) {}

  async open(event: MouseEvent) {
    const { width, left, top, height } = this.el.nativeElement.getBoundingClientRect();
    let position = { x: left + width - 3, y: top + height + 5 };
    const ref = this.contextMenuService.open(
      position,
      {
        items: this.items,
        onInvoke: (item: ResultContextMenuItem, trigger) => {
          this.invoke.emit({ item, trigger });
        },
      },
      { position: 'left' }
    );

    ref.destroy$.pipe(untilDestroyed(this)).subscribe(() => {});
  }
}
